import { outcomeDistribution } from "../metrics.ts";
import type { Totals } from "../domain.ts";

// Series colors theo Eastgate tokens: semantic cho kết quả rõ nghĩa,
// thang xám ink cho các bậc rơi trung tính. Key khớp OutcomeSlice.key.
const OUTCOME_COLORS: Record<string, string> = {
  onboarded: "#1FA97D",
  failedInterview: "#3A4252",
  failedCV: "#6B7280",
  notApplied: "#94A3B8",
  noResponse: "#CBD5E1",
};

export type OutcomesProps = { totals: Totals };

export function Outcomes({ totals }: OutcomesProps) {
  const dist = outcomeDistribution(totals);
  // max làm mốc 100% của thanh bar; sàn 1 để không chia cho 0.
  const max = Math.max(...dist.map((d) => d.count), 1);

  return (
    <>
      {dist.map((d) => (
        <div className="outcome-row" key={d.key}>
          <div className="outcome-top">
            <span>
              <span className="dot" style={{ background: OUTCOME_COLORS[d.key] }} />
              {d.label}
            </span>
            <span>
              <span className="cnt">{d.count}</span> <span className="pct">({Math.round(d.pct)}%)</span>
            </span>
          </div>
          <div className="outcome-bar">
            <i style={{ width: `${(d.count / max) * 100}%`, background: OUTCOME_COLORS[d.key] }} />
          </div>
        </div>
      ))}
    </>
  );
}
